const SELECTOR = {
  FORM: "form",
  WRAPPER: "#FacetsWrapperDesktop",
  COLLECTION: ".collection",
  PRODUCT_LIST: "[data-products-list]",
  FILTERS: "#collectionFiltersModal",
  HEADER: ".header-list",
  FILTER_BUTTON_SPINNER: "#filter-button-spinner",
  FILTER_BUTTON_RESULTS: "#filter-button-results",
  FILTER_AJAX_PAGINATION: "#AjaxinatePagination",
};

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce(
      (event) => this.onSubmitHandler(event),
      500
    );

    const facetForm = this.querySelector(SELECTOR.FORM);
    facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector(SELECTOR.WRAPPER);
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    FacetFiltersForm.enableLoading();

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderBlocks(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderBlocks(html);
  }

  static renderBlocks(html) {
    const refreshedSectionDocument = new DOMParser().parseFromString(
      html,
      "text/html"
    );

    [
      SELECTOR.PRODUCT_LIST,
      SELECTOR.FILTERS,
      SELECTOR.HEADER,
      SELECTOR.FILTER_AJAX_PAGINATION,
    ].forEach(
      (block) =>
        (document.querySelector(block).innerHTML =
          refreshedSectionDocument.querySelector(block).innerHTML)
    );
    FacetFiltersForm.disableLoading();
    document.dispatchEvent(new Event("filtered"));
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }

  static getSections() {
    return [
      {
        section: document.querySelector(SELECTOR.PRODUCT_LIST).dataset.id,
      },
    ];
  }

  static enableLoading() {
    const buttonFilter = document.querySelector(SELECTOR.FILTER_BUTTON_RESULTS);
    const spinner = document.querySelector(SELECTOR.FILTER_BUTTON_SPINNER);

    spinner.setAttribute("aria-hidden", false);
    spinner.hidden = false;
    buttonFilter.hidden = true;
    buttonFilter.closest("button").disabled = true;
  }

  static disableLoading() {
    const buttonFilter = document.querySelector(SELECTOR.FILTER_BUTTON_RESULTS);
    const spinner = document.querySelector(SELECTOR.FILTER_BUTTON_SPINNER);

    spinner.setAttribute("aria-hidden", true);
    spinner.hidden = true;
    buttonFilter.hidden = false;
    buttonFilter.closest("button").disabled = false;
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll(
      "facet-filters-form form"
    );

    const forms = [];
    sortFilterForms.forEach((form) =>
      forms.push(this.createSearchParams(form))
    );
    this.onSubmitForm(forms.join("&"), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1
          );
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    form.onActiveFilterClick(event);
  }
}

customElements.define("facet-remove", FacetRemove);
